import IconButton from "../IconButton";
import { Container } from "./styles";
import InlineSVG from "react-inlinesvg";

/**
 * @description A component that allows the user to toggle the visibility of an element (character, field, etc.)
 * @param {Object} props
 * @param {Function} props.onClick - The function to toggle the visibility of the element
 * @param {boolean} props.isVisible - Whether the element (character, field, etc.) is visible to Sudowrite
 * @param {boolean} props.small - Whether the button should be small
 * @param {number} props.hoverTipOffsetX - The offset of the hover tip from the button
 * @param {number} props.hoverTipOffsetY - The offset of the hover tip from the button
 * @param {boolean} props.shouldShow - Whether the controller itself should be shown (e.g., when parent is hovered)
 * @returns {JSX.Element}
 */
export default function ElementVisibilityController({ onClick, isVisible, small = false, hoverTipOffsetX = 0, hoverTipOffsetY = 0, shouldShow = false, faded = true, isMenuButton = false }) {
  const elementIsHiddenFromSudowrite = !isVisible;
  const shouldBeVisible = shouldShow || elementIsHiddenFromSudowrite;

  const handleClick = () => {
    onClick();
    document.activeElement.blur(); // counteracts :focus-within styling - makes it so that eye icon disappears when clicked and element is set to visible
  };

  return (
    <>
      {isMenuButton ? (
        // in narrow widths, we collapse this into the ... menu
        // so we want to give it the same classes as the other menu items
        <div
          className="menu-item"
          onClick={handleClick}
        >
          <div className="icon">
            <InlineSVG src={isVisible ? "/assets/visible.svg" : "/assets/hidden.svg"} />
          </div>
          <div className="label">{isVisible ? "Visible to Sudowrite" : "Hidden from Sudowrite"}</div>
        </div>
      ) : (
        <Container
          className="element-visibility-controller"
          hoverTipOffsetX={hoverTipOffsetX}
          hoverTipOffsetY={hoverTipOffsetY}
          shouldBeVisible={shouldBeVisible}
          $faded={faded}
        >
          <IconButton
            src={isVisible ? "/assets/visible.svg" : "/assets/hidden.svg"}
            onClick={handleClick}
            smartFill={false}
            hoverTipText={isVisible ? "Visible to Sudowrite" : "Hidden from Sudowrite"}
            disableHoverTipArrow={true}
            size={small ? "32" : "40"}
            aria-label={isVisible ? "Hide element from Sudowrite" : "Make element visible to Sudowrite"}
          />
        </Container>
      )}
    </>
  );
}
